import { post, get, put, del, setTokens } from './client.js';
import type {
  LoginRequest,
  LoginResponse,
  User,
  PaginatedResponse,
  CreateUserRequest,
  UpdateUserRequest,
  UserPermissionsResponse,
  ApiTokenCreated,
  ApiTokenListResponse,
  ApiTokenCreateRequest,
} from '../types/index.js';

type TokenResponse = Omit<LoginResponse, 'user'>;

export const authApi = {
  login: (data: LoginRequest) => post<LoginResponse>('/auth/login', data),
  refresh: async () => {
    const response = await post<TokenResponse>('/auth/refresh');
    setTokens(response.access_token, response.refresh_token);
    return response;
  },
  logout: () => post('/auth/logout'),
  me: () => get<User>('/auth/me'),
};

export const userApi = {
  list: (params?: { page?: number; per_page?: number; role?: string }) => {
    const query = new URLSearchParams();
    if (params?.page) query.append('page', params.page.toString());
    if (params?.per_page) query.append('per_page', params.per_page.toString());
    if (params?.role) query.append('role', params.role);
    return get<PaginatedResponse<User>>(`/users?${query.toString()}`);
  },

  me: () => get<User>('/users/me'),

  create: (data: CreateUserRequest) =>
    post<User>('/users', data),

  update: (id: number, data: UpdateUserRequest) =>
    put<User>(`/users/${id}`, data),

  delete: (id: number) =>
    del<{ message: string }>(`/users/${id}`),

  getMyPermissions: () => get<UserPermissionsResponse>('/permissions/me/permissions'),
};

export const apiTokenApi = {
  list: () => get<ApiTokenListResponse>('/auth/tokens'),
  create: (data: ApiTokenCreateRequest) => post<ApiTokenCreated>('/auth/tokens', data),
  revoke: (id: number) => del<{ message: string }>(`/auth/tokens/${id}`),
};
